'use client';

import * as React from 'react';

/**
 * Set by the Navbar's desktop actions row. An attached, labelled trigger
 * inside it pins to the bar top (`self-start`) at its own height, so the
 * open tab is flush with the bar top and the attached panel hangs off the
 * tab's bottom edge (over the lower part of the bar). Stretching to the
 * bar height pushed the panel down to the bar's bottom edge.
 */
const PopoverInsideNavbarBarContext = React.createContext(false);

export const PopoverInsideNavbarBarProvider =
  PopoverInsideNavbarBarContext.Provider;

export function usePopoverInsideNavbarBar(): boolean {
  return React.useContext(PopoverInsideNavbarBarContext);
}
